import { ObjectValues } from 'helpers/types';

import { IForBankSections, IForBankSubSections } from './forBank';
import { IForInvestorsSections, IForInvestorSubSection } from './forInvestors';
import { IOnePageSections } from './onePage';
import { IOnePageShortSections } from './onePageShort';

export const PDF = {
  TITLE_PAGE_AND_TABLE_OF_CONTENTS: 'TITLE_PAGE_AND_TABLE_OF_CONTENTS'
} as const;

export type IPdfTitlePageSection = ObjectValues<typeof PDF>;

export type IUnitedSections = IForBankSections | IOnePageSections | IOnePageShortSections | IForInvestorsSections | IPdfTitlePageSection;
export type IUnitedSubSections = IForBankSubSections | IForInvestorSubSection;
